import React from "react";
import { useNavigate } from "react-router-dom";

const ProfileMenuItem = ({ icon, label, onClick, path }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (path) {
      navigate(path);
    }
  };

  return (
    <li className="dropdown-item d-flex align-items-center gap-2" style={{ cursor: 'pointer' }} onClick={handleClick}>
      <span>{icon}</span> {label}
    </li>
  );
};

export default ProfileMenuItem;